<template>
    <el-row class="container">
        <el-col :span="24" class="header">
            <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
                <!--				{{collapsed?'':sysName}}-->
                <el-image :src="logo"></el-image>
            </el-col>
            <el-col :span="20" style="color: white">
                <span style="font-size: 1.17em">经销商后台管理系统</span>
                <el-link style="margin-left: 5px;font-weight: bold;float: right;color: white" @click.native="logout">退出登录</el-link>
            </el-col>
            <!--			<el-col :span="4" class="userinfo">-->
            <!--				<el-dropdown trigger="hover">-->
            <!--					<span class="el-dropdown-link userinfo-inner"><img :src="this.sysUserAvatar" /> {{sysUserName}}</span>-->
            <!--					<el-dropdown-menu slot="dropdown">-->
            <!--						<el-dropdown-item>我的消息</el-dropdown-item>-->
            <!--						<el-dropdown-item>设置</el-dropdown-item>-->
            <!--						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>-->
            <!--					</el-dropdown-menu>-->
            <!--				</el-dropdown>-->
            <!--			</el-col>-->
        </el-col>
        <el-col :span="24" class="main">
            <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
                <!--导航菜单-->
                <el-menu :default-active="$route.path" class="el-menu-vertical-demo"
                         @open="handleopen" @close="handleclose" @select="handleselect"
                         unique-opened router v-show="!collapsed">
                    <template v-for="(item,index) in menuList" v-if="!item.hidden">
                        <!--						<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">-->
                        <!--							<i :class="item.iconCls"></i>{{item.children[0].name}}-->
                        <!--						</el-menu-item>-->
                        <el-submenu :index="index+''" v-if="!item.leaf&&item.children">
                            <template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path"
                                          v-if="!child.hidden">{{child.name}}
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="item.path" :key="item.path">
                            <i :class="item.iconCls"></i>{{item.name}}
                        </el-menu-item>
                        <!--						<el-submenu  v-else>-->
                        <!--							<template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>-->
                        <!--						</el-submenu>-->
                    </template>
                </el-menu>
                <!--导航菜单-折叠后-->
                <!--				<ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">-->
                <!--					<li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">-->
                <!--						<template v-if="!item.leaf">-->
                <!--							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" -->
                <!--								 @mouseout="showMenu(index,false)">-->
                <!--								<i :class="item.iconCls"></i>-->
                <!--							</div>-->
                <!--							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" -->
                <!--								@mouseout="showMenu(index,false)"> -->
                <!--								<li v-for="child in item.children" v-if="!child.hidden" :key="child.path" -->
                <!--									class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" -->
                <!--									@click="$router.push(child.path)">{{child.name}}</li>-->
                <!--							</ul>-->
                <!--						</template>-->
                <!--						<template v-else>-->
                <!--							<li class="el-submenu">-->
                <!--								<div class="el-submenu__title el-menu-item" -->
                <!--									 style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" -->
                <!--									 :class="$route.path==item.children[0].path?'is-active':''" -->
                <!--									 @click="$router.push(item.children[0].path)">-->
                <!--									<i :class="item.iconCls"></i>-->
                <!--								</div>-->
                <!--							</li>-->
                <!--						</template>-->
                <!--					</li>-->
                <!--				</ul>-->
            </aside>
            <section class="content-container">
                <div class="grid-content bg-purple-light">
                    <!--					<el-col :span="24" class="breadcrumb-container">-->
                    <!--						<strong class="title">{{$route.name}}</strong>-->
                    <!--						<el-breadcrumb separator="/" class="breadcrumb-inner">-->
                    <!--							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">-->
                    <!--								{{ item.name }}-->
                    <!--							</el-breadcrumb-item>-->
                    <!--						</el-breadcrumb>-->
                    <!--					</el-col>-->
                    <el-col :span="24" class="content-wrapper">
                        <transition name="fade" mode="out-in">
                            <router-view></router-view>
                        </transition>
                    </el-col>
                </div>
            </section>
        </el-col>
    </el-row>
</template>

<script>
    import Main from "./Main";
    import Table from "./nav1/Table";
    import Form from "./nav1/Form";
    import user from "./nav1/user";
    import Page4 from "./nav2/Page4";
    import Page5 from "./nav2/Page5";
    import Page6 from "./nav3/Page6";

    export default {
        data() {
            return {
                logo: '/static/u30.png',
                sysName: 'Miaotu',
                collapsed: false,
                sysUserName: '',
                sysUserAvatar: '',
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                menuList: [
                    //$router.options.routes
                    {
                    	path: '/main',
                    	name: '概览(首页)',
                    	iconCls: 'el-icon-tickets',
                    },
                    {
                        path: '/',
                        name: '商家管理',
                        iconCls: 'el-icon-news',
                        children: [
                            {path: '/merchantEnquiry', name: '商家列表&查询'},
                            {path: '/merchantRegist', name: '商家注册'}
                        ]
                    },
                    {
                        path: '/',
                        name: '划拨管理',
                        iconCls: 'el-icon-date',
                        children: [
                            {path: '/transferEnquiry', name: '划拨记录&查询'},
                            {path: '/transfer', name: '划拨云豆'}
                        ]
                    },
                    {
                        path: '/',
                        name: '购买管理',
                        iconCls: 'el-icon-goods',
                        children: [
                            {path: '/purchaseEnquiry', name: '购买记录&查询'}
                        ]
                    },
                    // {
                    // 	path: '/',
                    // 	name: '导航',
                    // 	iconCls: 'el-icon-message',
                    // 	children: [
                    // 		{ path: '/table', name: 'Table'},
                    // 		{ path: '/form', name: 'Form'},
                    // 		{ path: '/user', name: '列表' },
                    // 		{ path: '/page4', name: '页面4' },
                    // 		{ path: '/page5', name: '页面5' },
                    // 		{ path: '/page6', name: '页面6' },
                    // 		{ path: '/echarts', name: 'echarts' },
                    // 	]
                    // },

                ]
            }
        },
        methods: {
            onSubmit() {
                console.log('submit!');
            },
            handleopen() {
                //console.log('handleopen');
            },
            handleclose() {
                //console.log('handleclose');
            },
            handleselect: function (a, b) {
            },
            //退出登录
            logout: function () {
                var _this = this;
                this.$confirm('确认退出吗?', '提示', {
                    //type: 'warning'
                }).then(() => {
                    sessionStorage.removeItem('user');
                    _this.$router.push('/login');
                }).catch(() => {

                });


            },
            //折叠导航栏
            collapse: function () {
                this.collapsed = !this.collapsed;
            },
            showMenu(i, status) {
                this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
            }
        },
        mounted() {
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
                this.sysUserName = user.name || '';
                this.sysUserAvatar = user.avatar || '';
            }

        }
    }

</script>

<style scoped lang="scss">
    @import '~scss_vars';

    .container {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;
        .header {
            height: 60px;
            line-height: 60px;
            background: $color-primary;
            color: #fff;
            .userinfo {
                text-align: right;
                padding-right: 35px;
                float: right;
                .userinfo-inner {
                    cursor: pointer;
                    color: #fff;
                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 20px;
                        margin: 10px 0px 10px 10px;
                        float: right;
                    }
                }
            }
            .logo {
                //width:230px;
                height: 60px;
                font-size: 22px;
                padding-left: 5px;
                padding-right: 20px;
                img {
                    width: 40px;
                    float: left;
                    margin: 10px 10px 10px 18px;
                }
                .txt {
                    color: #fff;
                }
            }
            .logo-width {
                width: 230px;
            }
            .logo-collapse-width {
                width: 60px
            }
            .tools {
                padding: 0px 23px;
                width: 14px;
                height: 60px;
                line-height: 60px;
                cursor: pointer;
            }
        }
        .main {
            display: flex;
            // background: #324057;
            position: absolute;
            top: 60px;
            bottom: 0px;
            overflow: hidden;
            aside {
                flex: 0 0 230px;
                width: 230px;
                // position: absolute;
                // top: 0px;
                // bottom: 0px;
                .el-menu {
                    height: 100%;
                }
                ul{
                    background: #f7f7f7;
                }
                li, .el-submenu__title {
                    font-weight: bold;
                }
                .collapsed {
                    width: 60px;
                    .item {
                        position: relative;
                    }
                    .submenu {
                        position: absolute;
                        top: 0px;
                        left: 60px;
                        z-index: 99999;
                        height: auto;
                        display: none;
                    }

                }
            }
            .menu-collapsed {
                flex: 0 0 60px;
                width: 60px;
            }
            .menu-expanded {
                flex: 0 0 230px;
                width: 230px;
            }
            .content-container {
                // background: #f1f2f7;
                flex: 1;
                // position: absolute;
                // right: 0px;
                // top: 0px;
                // bottom: 0px;
                // left: 230px;
                overflow-y: scroll;
                padding: 20px;
                .breadcrumb-container {
                    //margin-bottom: 15px;
                    .title {
                        width: 200px;
                        float: left;
                        color: #475669;
                    }
                    .breadcrumb-inner {
                        float: right;
                    }
                }
                .content-wrapper {
                    background-color: #fff;
                    box-sizing: border-box;
                }
            }
        }
    }
</style>
<style>
    .el-table td, .el-table th{
        padding: 6px 0;
        font-size: 14px;
        font-family: Helvetica Neue, Helvetica, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    }
</style>



// WEBPACK FOOTER //
// Home.vue?55fdbcf1